// Copyright (c) billwerk GmbH. All rights reserved.
'use strict';

var PasswordResetController = function ($scope, $location, $http, $routeParams, $rootScope) {
    if ($routeParams.language) {
        $scope.setLang($routeParams.language);
    } else {
        $scope.setLang($rootScope.defaultLanguage);
    }

    $scope.send = function () {
        var dto = { email: $scope.email };
        $http({
            method: "POST",
            url: "/api/v1/passwordReset",
            data: dto,
            cache: false
        }).then(function (response) {
            switch (response.data.action) {
                case 'reset': {
                    $location.path("/passwordResetSent");
                    break;
                }
                case 'confirm': {
                    $location.path("/proceedSignupConfirmation");
                    break;
                }
            }            
        });
    };
};
PasswordResetController.$inject = ['$scope', '$location', '$http', '$routeParams', '$rootScope'];
